import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-template-settings-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    LoadingComponent,
  ],
  templateUrl: './template-settings-form.component.html',
  styleUrl: './template-settings-form.component.scss',
})
export class TemplateSettingsFormComponent implements OnInit {
  @Input() id: number = 0;
  @Input() template: any = null;
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);
  public saveForm: FormGroup = new FormGroup({});
  public selectedFile: File | null = null;
  public fileError = '';

  readonly typeOptions = [
    { value: 'blade', label: 'Blade' },
    { value: 'image', label: 'Imagen' },
    { value: 'pdf', label: 'PDF' },
  ];

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();
    if (this.template) {
      this.saveForm.patchValue(this.template);
    }
  }

  createForm() {
    this.saveForm = new FormGroup({
      short_code: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      type: new FormControl('blade'),
      label: new FormControl(''),
      is_active: new FormControl(true),
    });
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.selectedFile = input.files?.[0] ?? null;
    this.fileError = '';
  }

  buildFormData(): FormData {
    const fd = new FormData();
    const v = this.saveForm.value;

    fd.append('short_code', v.short_code ?? '');
    fd.append('type', v.type ?? 'blade');
    fd.append('label', v.label ?? '');
    fd.append('is_active', v.is_active ? '1' : '0');

    if (this.selectedFile) {
      fd.append('file', this.selectedFile, this.selectedFile.name);
    }

    if (this.id) {
      fd.append('_method', 'PUT');
    }

    return fd;
  }

  saveEntity() {
    if (!this.saveForm.valid) {
      Utils.notification.alert('Debe completar todos los campos obligatorios');
      return;
    }

    if (!this.id && !this.selectedFile) {
      this.fileError = 'Debe seleccionar un archivo';
      return;
    }

    this.saving.set(true);
    const fd = this.buildFormData();

    this.apiService.upload(Urls.urls.templatesSettings, fd, this.id).subscribe({
      next: (response: any) => {
        Utils.notification.success(this.id ? 'Plantilla actualizada' : 'Plantilla creada');
        this.acceptFunction.emit(response);
        this.closeFormFunction();
      },
      error: (error: any) => {
        Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al guardar la plantilla');
        this.saving.set(false);
        this.cdr.detectChanges();
      },
      complete: () => {
        this.saving.set(false);
      }
    });
  }

  acceptFormFunction() { this.saveEntity(); }
  closeFormFunction() { this.closeFunction.emit(); }
}
